import Swiper from 'swiper'

window.addEventListener('DOMContentLoaded', () => {
  const swiper03 = new Swiper('.slider .swiper-container', {
    'loop': false,
    'slidesPerView': 1.4,
    'centeredSlides': false,
    'spaceBetween': 20,
    'pagination': '.swiper-pagination',
    'navigation': {
      'nextEl': '.swiper-button-next',
      'prevEl': '.swiper-button-prev'
    },
    'breakpoints': {
      '767': {
        'spaceBetween': 0,
        'slidesPerView': 3
      }
    }
  })

  const swiper04 = new Swiper('.slider3 .swiper-container', {
    'loop': true,
    'slidesPerView': 1.4,
    'centeredSlides': true,
    'spaceBetween': 20,
    'breakpoints': {
      '767': {
      'slidesPerView': 'auto'
      }
    }
  })
  const swiper05 = new Swiper('.slider--300 .swiper-container', {
    'loop': false,
    'slidesPerView': 'auto',
    'centeredSlides': false,
    'spaceBetween': 0,
    'pagination': '.swiper-pagination',
    'navigation': {
      'nextEl': '.swiper-button-next',
      'prevEl': '.swiper-button-prev'
    },
    'scrollbar': {
      'el': '.swiper-scrollbar'
    }
  })
}, false)

window.addEventListener('DOMContentLoaded', () => {
  const bannerSlider = new Swiper('.top-banner.slider', {
    'loopAdditionalSlides': 2,
    'centeredSlides': true,
    'slidesPerView': 1,
    'initialSlide': 0,
    'autoplay': {
      'delay': 5000
    },
    'speed': 1000,
    'spaceBetween': 20,
    'loop': true,
    'observer': true,
    'observeParents': true,
    'navigation': {
      'nextEl': '.swiper-button-next',
      'prevEl': '.swiper-button-prev'
    },
    'breakpoints': {
      '767': {
        'spaceBetween': 37,
        'slidesPerView': 3,
        'centeredSlides': false,
        'initialSlide': 0
      },
      '414': {
        'slidesPerView': 1.4
      },
      '375': {
        'slidesPerView': 1.35
      }
    }
  })

  if (window.innerWidth < 768){
    const caseSlider = new Swiper('.m_caseSimulation .swiper-container', {
      'loop': false,
      'slidesPerView': 1.3,
      'spaceBetween': 12,
      'scrollbar': {
        'el': '.swiper-scrollbar',
        'draggable': true
      }
    })
  }
})

window.addEventListener('DOMContentLoaded', () => {
  const reviewSlider = new Swiper('.m_review-slide .slider', {
    'centeredSlides': true,
    'slidesPerView': 1.2,
    'spaceBetween': 20,
    'initialSlide': 0,
    'loop': true,
    'navigation': {
      'nextEl': '.swiper-button-next',
      'prevEl': '.swiper-button-prev'
    },
    'breakpoints': {
      '767': {
        'slidesPerView': 'auto',
        'spaceBetween': 30
      }
    }
  })
})

window.addEventListener('DOMContentLoaded', () => {
  const caseListSlider = new Swiper('.m_caseList-slide .slider', {
    'centeredSlides': true,
    'spaceBetween': 20,
    'slidesPerView': 'auto',
    'initialSlide': 0,
    'loop': true,
    'navigation': {
      'nextEl': '.swiper-button-next',
      'prevEl': '.swiper-button-prev'
    },
    'breakpoints': {
      '767': {
        'spaceBetween': 30
      }
    }
  })
})

window.addEventListener('DOMContentLoaded', () => {

  const swiper06 = new Swiper('.slider--card .swiper-container', {
    'loop': false,
    'slidesPerView': 1.4,
    'centeredSlides': false,
    'scrollbar': {
      'el': '.swiper-scrollbar',
      'draggable': true
    },
    'breakpoints': {
      '767': {
        'slidesPerView': 'auto'
      }
    }
  })
})

window.addEventListener('resize', switchSwiper)
window.addEventListener('DOMContentLoaded', switchSwiper)
function switchSwiper(){
  const swiperElements = document.querySelectorAll('.slider2 .swiper-container')
  const SWIPER_THRESHOLD = 768
  const swipers = Array.from(swiperElements).map((elm) => elm.swiper)
  const isSwiperExists = swipers.every((swiper) => typeof swiper !== 'undefined' && swiper !== null)

  if (window.innerWidth >= SWIPER_THRESHOLD && !isSwiperExists){
    const _swiper = new Swiper(swiperElements, {
      'pagination': '.swiper-pagination',
      'navigation': {
        'prevEl': '.swiper-button-prev',
        'nextEl': '.swiper-button-next'
      },
      'loop': false,
      'slidesPerView': 'auto'
    })
  } else if (window.innerWidth < SWIPER_THRESHOLD && isSwiperExists){
    swipers.forEach((swiper) => swiper.destroy())
  }
}

// TOPバナースライダー（SPのみカルーセル）
let topBannerSwiper = null

function initOrDestroySwiper() {
  const isSP = window.matchMedia('(max-width: 767px)').matches
  const sliderEl = document.querySelector('.topBannerSlider')

  if (!sliderEl) {
    return
  }

  if (isSP && !topBannerSwiper) {
    topBannerSwiper = new Swiper(sliderEl, {
      'loopAdditionalSlides': 2,
      'centeredSlides': true,
      'slidesPerView': 1,
      'initialSlide': 0,
      'autoplay': {
        'delay': 5000
      },
      'speed': 1000,
      'spaceBetween': 20,
      'loop': true,
      'observer': true,
      'observeParents': true,
      'navigation': {
        'nextEl': '.swiper-button-next',
        'prevEl': '.swiper-button-prev'
      },
      'breakpoints': {
        '414': { 'slidesPerView': 1.4 },
        '375': { 'slidesPerView': 1.35 }
      }
    })
  } else if (!isSP && topBannerSwiper) {
    topBannerSwiper.destroy(true, true)
    topBannerSwiper = null
  }
}

window.addEventListener('DOMContentLoaded', () => {
  initOrDestroySwiper()
})

let resizeTimer = null

window.addEventListener('resize', () => {
  clearTimeout(resizeTimer)

  resizeTimer = setTimeout(() => {
    initOrDestroySwiper()
  }, 200)
})
